<script>
export default {
  props: {
    podeVoltar:    { type: Boolean, default: true },
    rotuloAvancar: { type: String,  default: 'Continuar' },
    rotuloVoltar:  { type: String,  default: 'Voltar' },
    carregando:    { type: Boolean, default: false },
    desabilitado:  { type: Boolean, default: false },
  },
}
</script>

<template>
  <div class="actions-row">
    <button
      v-if="podeVoltar"
      type="button"
      class="btn btn--ghost"
      :disabled="carregando"
      @click="$emit('voltar')"
    >
      {{ rotuloVoltar }}
    </button>
    <span v-else />

    <button
      type="button"
      class="btn btn--primary"
      :disabled="carregando || desabilitado"
      @click="$emit('avancar')"
    >
      <span v-if="carregando" class="spinner" aria-hidden="true" />
      {{ carregando ? 'Aguarde...' : rotuloAvancar }}
    </button>
  </div>
</template>

<style scoped lang="scss">
@import "~@/design/tokens";

.spinner {
  width: 16px;
  height: 16px;
  border-radius: 50%;
  border: 2px solid rgba(255,255,255,.4);
  border-top-color: $text-on-brand;
  animation: spin .7s linear infinite;
  display: inline-block;
  margin-right: $space-2;
}

@keyframes spin { to { transform: rotate(360deg); } }
</style>
